export const TestData = [
  {
    id: 1,
    testname: "CBC Test (Complete Blood Count)"
  },
  {
    id: 2,
    testname: "CRP Test (C - Reactive Protein)"
  },
  {
    id: 3,
    testname: "PPBS Test (Post-Prandial Blood Sugar)"
  },
  {
    id: 4,
    testname: "Urine Routine Test"
  },
  {
    id: 5,
    testname: "Thyroid Profile (T3 T4 TSH) Test"
  },
  {
    id: 6,
    testname: "FBS (Fasting Blood Sugar )Test"
  },
  {
    id: 7,
    testname: "FBS (Fasting Blood Sugar )Test"
  },
  {
    id: 8,
    testname: "FBS (Fasting Blood Sugar )Test"
  },
  {
    id: 9,
    testname: "FBS (Fasting Blood Sugar )Test"
  }
];



export const CategoryData= [
  {
    id: 1,
    Categoryname: "Pregnancy"
  },
  {
    id: 2,
    Categoryname: "Hospital Health Check"
  },
  {
    id: 3,
    Categoryname: "Blood Studies"
  },
   {
    id: 4,
    Categoryname: "Allergy"
  },
  {
    id: 5,
    Categoryname: "Tax Saver"
  },
  {
    id: 6,
    Categoryname: "Vitamin"
  }
  
];
 